import api from 'api/api'
import * as cache from 'state/cache'
import useStore from 'state/knovStore'
import {
    refreshChildQuestInBackground,
    seedChildQuestFromAnswer,
} from 'refactor/panels/primeChildQuestForOpen'

// Opens the thread that contains a referenced answer (remix source, Illustrate/Film source
// post) in the panel to the right, anchored on that answer. The answer's own child quest is
// the navigation target so the referenced post renders as the thread head.
export default async function openSourceAnswerThread({
    answerId,
    openRight,
    missingNotice = 'Unable to find the referenced post.',
    missingThreadNotice = 'No thread found for the referenced post.',
}) {
    if (!answerId || typeof openRight !== 'function') return

    let sourceAnswer = cache.getCachedAnswer(answerId)
    try {
        if (!sourceAnswer) {
            sourceAnswer = await api.getAnswer(answerId)
            if (sourceAnswer?.id) cache.cacheAnswer(sourceAnswer)
        }
    } catch (error) {
        sourceAnswer = null
    }

    if (!sourceAnswer?.id) {
        useStore.getState().showGlobalNotice(missingNotice, { variant: 'error' })
        return
    }

    let childQuestId = sourceAnswer.child_quests?.[0]?.id
    if (!childQuestId) {
        const commentQuest = await api.getCommentQuest(sourceAnswer.id)
        childQuestId = commentQuest?.id
    }

    if (!childQuestId) {
        useStore.getState().showGlobalNotice(missingThreadNotice, {
            variant: 'error',
        })
        return
    }

    seedChildQuestFromAnswer(sourceAnswer, childQuestId)
    await openRight({ questId: childQuestId, answerId: sourceAnswer.id })
    refreshChildQuestInBackground(childQuestId)
}
